<ng-template>
    <div>
      Are you sure you want to delete this {{ entity }}?
      <button (click)="close()">No</button>
      <button (click)="confirmAction()">Yes</button>
    </div>
  </ng-template>
  <ng-content></ng-content>